// QuestionSetCard.js
import React from 'react';

import { useNavigate } from "react-router-dom";

import './QuestionSetCard.css';

const formatDateTime = (isoString) => {
  const date = new Date(isoString);
  const pad = (n) => (n < 10 ? '0' + n : n);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const QuestionSetCard = ({ questionSet, imageUrl }) => {

	const navigate = useNavigate();

	console.log('questionSet:', questionSet);

	return (
	  <div className="d-flex rounded submitted-question-set-card-div" 
	  	style={{ borderBottom: "1px solid #eee", padding: "12px 5px 18px 15px", cursor: "pointer" }}
	  >

	  	<img
	      src={imageUrl}
	      alt={questionSet.label || 'Follower'}
	      style={{ width: '55px', height: '55px', borderRadius: '50%', marginRight: '20px' }}
	      onClick={(e) => { 
	      	e.stopPropagation(); 
	      	navigate(`/myInfo/storeMenu/stores/${questionSet._id}`); 
	      }}
	    />

	    <div className="d-flex flex-column justify-content-center">
		    <h6 className="mb-1">{questionSet.label}</h6>
		    <small className="text-muted">最近填寫時間: {formatDateTime(questionSet.updatedAt)}</small>
		  </div>
	  </div>
  );
};

export default QuestionSetCard;